import React, { Component } from "react";

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Icon from '@material-ui/core/Icon';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Tooltip from '@material-ui/core/Tooltip';

class Chat extends Component {
	constructor(props) {
        super(props);
		this.state= {
			dialogOpen: false,
			message: ""
		}
		this.handleOpen = this.handleOpen.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleSend = this.handleSend.bind(this);
		this.handleChange = this.handleChange.bind(this);
    }
	
	handleOpen(){
		this.setState({dialogOpen: true});
	};
	
	handleClose(){
		this.setState({dialogOpen: false});
	};
	
	handleChange(e) {
		e.preventDefault();
		this.setState({message: e.target.value});
	}
	
	handleSend(e){
		if(this.state.message.trim().length>0){
			this.props.sendMessage(this.props.orderId, this.state.message);
		}
		this.handleClose();
	};
	
	render() {
		const rows = [];
		if(typeof this.props.messages==="undefined" || this.props.messages==="undefined"){
			return "";
		}
		let icona = (this.props.messages.length>0) ? String.fromCharCode(59428) : String.fromCharCode(59397);
		for (var i = 0; i < this.props.messages.length; i++) {
			let clase1 = this.props.messages[i].remitentRole=="CUSTOMER" ? "msgCli" : "msgTrad";
			let clase2 = this.props.messages[i].remitentRole=="CUSTOMER" ? "nomCli" : "nomTrad";
			//rows.push(<Tooltip placement="left" title={new Intl.DateTimeFormat('es-ES', {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric',  minute: 'numeric', hour12: false}).format(new Date(this.props.messages[i].date))}><Box class={clase1}><span class={clase2}>{this.props.messages[i].remitentUsername}: </span>{this.props.messages[i].message}</Box></Tooltip>);
			rows.push(<Box class={clase1}><span class={clase2}>[{new Intl.DateTimeFormat('es-ES', {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric',  minute: 'numeric', hour12: false}).format(new Date(this.props.messages[i].date))}] {this.props.messages[i].remitentUsername}: </span>{this.props.messages[i].message}</Box>);
		}
		return (
		<span>
			<Dialog open={this.state.dialogOpen} onClose={this.handleClose} fullWidth={true} maxWidth = {'md'}>
				<DialogTitle>Messages</DialogTitle>
				<DialogContent dividers>
					<DialogContentText>
						{rows}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<TextField
						autoFocus
						margin="dense"
						id="messageText"
						label="Write new message"
						fullWidth
						onChange={this.handleChange}
					/>
					<Button onClick={this.handleSend} color="primary">
					SEND
					</Button>
				</DialogActions>
			</Dialog>
			<Tooltip placement="top" title={this.props.tooltip}><Icon onClick={() => { this.handleOpen(); }} style={{ fontFamily: "tipoecl", fontSize: "26px", color: "#000", padding: 0, cursor: "pointer"}}>{icona}</Icon></Tooltip>
		</span>
		);
  }
};

export default Chat;